import React from 'react'
import tw from 'tailwind-styled-components'
import {ContentOnHover} from './content-on-hover'
import {TooltipContainer} from './tooltip-container'
import {Position, ToolTipPosition} from './tooltip-position'

export interface Props {
  children?: React.ReactNode
  tooltipChildren?: React.ReactNode
  tooltipPosition?: 'right' | 'down'
  offsetX?: number
  offsetY?: number
  dark?: boolean
  paddings?: 12 | 16
  centerY?: boolean
  arrowPosition?: 'up-left'
}

const arrowPositions: {[key in Position]: Position} = {
  left: 'right',
  right: 'left',
  up: 'down',
  down: 'up'
}

/**
 * @deprecated use Tooltip instead
 * import {Tooltip} from '@components/common/tooltip/tooltip'
 */
export const ToolTip = (props: Props) => {
  const {children, tooltipPosition = 'right', offsetX = 0, offsetY = 0} = props
  const {tooltipChildren, dark = false, paddings = 12, centerY = false} = props

  const arrowPosition = props.arrowPosition || arrowPositions[tooltipPosition]

  if (!tooltipChildren) {
    return <>{children}</>
  }

  const content = (
    <>
      <ToolTipPosition
        tooltipPosition={tooltipPosition}
        offsetX={offsetX}
        offsetY={offsetY}
        centerY={centerY}
      >
        <TooltipContainer
          arrowPosition={arrowPosition}
          dark={dark}
          paddings={paddings}
        >
          {tooltipChildren}
        </TooltipContainer>
      </ToolTipPosition>
      <TwPlug $position={tooltipPosition} />
    </>
  )

  return (
    <ContentOnHover content={content}>
      <div>{children}</div>
    </ContentOnHover>
  )
}

/* Это заглушка для курсора, чтобы не слетал hover */
export const TwPlug = tw.div<{$position: Position}>`
  h-full
  top-0
  absolute
  min-h-20
  ${p => getTwPlugClasses(p.$position)}
`

const getTwPlugClasses = (pos: Position) => {
  if (pos === 'right') {
    return 'left-full w-full'
  }

  if (pos === 'down') {
    return 'top-full w-[200%]'
  }

  throw new Error('Not implemented')
}
